import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f20e316"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = { class: "table_sle" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("操作记录")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("添加开票")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 查看开票 ")
const _hoisted_13 = {
  key: 1,
  style: {"font-size":"12px"}
}
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "商户名称：", -1))
const _hoisted_16 = { class: "txt-333" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "交互方式：", -1))
const _hoisted_19 = { class: "txt-333" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("邮件发送")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("快递邮寄")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("其它方式")
const _hoisted_23 = {
  class: "info-item",
  style: {"align-items":"flex-start"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "发票凭证：", -1))
const _hoisted_25 = { class: "txt-333" }
const _hoisted_26 = {
  key: 2,
  style: {"font-size":"12px"}
}
const _hoisted_27 = { class: "info-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "商户名称：", -1))
const _hoisted_29 = { class: "txt-333" }
const _hoisted_30 = {
  key: 0,
  class: "info-item"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "交付方式：", -1))
const _hoisted_32 = { class: "txt-333" }
const _hoisted_33 = {
  key: 1,
  class: "info-item"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "添加时间：", -1))
const _hoisted_35 = { class: "txt-333" }
const _hoisted_36 = {
  key: 2,
  class: "info-item"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "添加人员：", -1))
const _hoisted_38 = { class: "txt-333" }
const _hoisted_39 = {
  key: 3,
  class: "info-item",
  style: {"align-items":"flex-start"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "发票凭证：", -1))
const _hoisted_41 = { class: "txt-333" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#ff687b"} }, "点击可放大查看图片凭证", -1))
const _hoisted_43 = {
  key: 4,
  class: "info-item"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "操作人员：", -1))
const _hoisted_45 = { class: "txt-333" }
const _hoisted_46 = {
  key: 5,
  class: "info-item"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "操作时间：", -1))
const _hoisted_48 = { class: "txt-333" }
const _hoisted_49 = {
  key: 6,
  class: "info-item"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "付款人姓名：", -1))
const _hoisted_51 = { class: "txt-333" }
const _hoisted_52 = {
  key: 7,
  class: "info-item"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "联系电话：", -1))
const _hoisted_54 = { class: "txt-333" }
const _hoisted_55 = {
  key: 8,
  class: "info-item",
  style: {"align-items":"flex-start"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-666 title-balel" }, "付款凭证：", -1))
const _hoisted_57 = { class: "txt-333" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#ff687b"} }, "点击可放大查看图片凭证", -1))
const _hoisted_59 = { class: "dialog-footer" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive } from "vue";
import moment from "moment";
import router from "@/router/index";
// import { Plus } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { merchantorderlist, addInvoice } from "@/api/Merchantapi";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const headerimg = ref("/compontsimg/ffjl.png");
const headercontent = ref("主要管理商户续费或扩店的订单管理，以及订单开票");
const state = reactive({
  formList: [
    {
      label: "商户全称",
      key: "merchantName",
      type: "input",
      placeholder: "请输入商户全称查询",
      clearable: true,
    },
    {
      label: "订单编号",
      key: "orderNo",
      type: "input",
      placeholder: "请输入订单编号查询",
      clearable: true,
    },
    {
      label: "类型",
      key: "type",
      type: "select",
      name: "valueName",
      clearable: true,
      optionList: [
        { labelName: "首购", value: "01" },
        { labelName: "续费", value: "02" },
        { labelName: "扩店", value: "03" },
      ],
      placeholder: "请选择类型",
      default: "",
    },
    {
      label: "开票状态",
      key: "invoiceStatus",
      type: "select",
      name: "valueName",
      clearable: true,
      optionList: [
        { labelName: "未开票", value: "01" },
        { labelName: "已开票", value: "02" },
      ],
      placeholder: "请选择开票状态",
      default: "",
    },

    {
      label: "选择时间",
      key: "datetime",
      type: "datetimerange",
      endPlaceholder: "结束时间",
      startPlaceholder: "开始时间",
      clearable: true,
    },
  ],
});
const imgurl = ref();
const btnLoading = ref(false);
const imgViewerVisible = ref(false);
const isLoading = ref(false);
const page = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const deliveryType = ref("01");
const invoiceCredentials = ref("");
const dialogTitle = ref();
const changeSelect = () => {
  console.log(state);
};

const tableColumn = ref([
  {
    prop: "orderNo",
    label: "订单编号",
  },
  {
    slotName: "orderStatus",
  },
  {
    slotName: "type",
  },
  {
    prop: "merchantId",
    label: "商户编号",
  },
  {
    slotName: "merchantName",
  },
  {
    prop: "renewalStoreNum",
    label: "续费/扩店门店",
  },
  {
    slotName: "orderPrice",
  },
  {
    slotName: "invoiceStatus",
  },
  {
    prop: "createTime",
    label: "时间",
  },
  {
    slotName: "info",
  },
  {
    slotName: "slotName",
  },
]);
const tableData = ref<any>([]);
// const toAddmerchant = () => {
//   router.push("/Merchantmanagement/Newmerchants");
// };
const openShow = ref(false);
const rowId = ref();
// const openstop = () => {
//   openShow.value = true;
// };
const num = ref(1);

// const imageUrl = ref("");

const params = ref<any>({
  endTime: "",
  invoiceStatus: "",
  merchantName: "",
  merchantSn: "",
  orderNo: "",
  orderStatus: "",
  pageNum: 1,
  pageSize: 10,
  startTime: "",
  type: "",
});
const submitForm = (val: any) => {
  console.log(val.value);
  let data = val.value;
  params.value.merchantName = data.merchantName;
  params.value.invoiceStatus = data.invoiceStatus;
  params.value.orderNo = data.orderNo;
  params.value.type = data.type;
  params.value.startTime = data.datetime ? moment(data.datetime[0]).valueOf() : "";
  params.value.endTime = data.datetime ? moment(data.datetime[1]).valueOf() : "";
  handleCurrentChange(1);
};
const handleCurrentChange = (val: any) => {
  console.log(val.value);
  if (val) {
    page.value.pageNum = val;
  }
  params.value.pageNum = page.value.pageNum;
  params.value.pageSize = page.value.pageSize;
  isLoading.value = true;
  merchantorderlist(params.value).then((res) => {
    tableData.value = res.data.list;
    page.value.total = res.data.total;
    page.value.pageNum = res.data.pageNum;
    tableData.value.forEach((item: any) => {
      item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
      item.invoiceCreateTime = moment(item.invoiceCreateTime).format("YYYY-MM-DD HH:mm:ss");
    });
    isLoading.value = false;
  });
};
handleCurrentChange(1);
const handleSizeChange = (num: any) => {
  page.value.pageSize = num;
  handleCurrentChange(1);
};
const dialogType = ref();
const dialogInfo = ref();
const btnClick = (row: any, type: string) => {
  dialogInfo.value = row;
  rowId.value = row.id;
  dialogType.value = type;
  dialogTitle.value = type == "add" ? "添加开票记录" : type == "oper" ? "查看订单操作记录" : type == "see" ? "查看开票记录" : "查看付费凭证";
  openShow.value = true;
};
const uploadChangeImg = (val: any) => {
  console.log(val);
  invoiceCredentials.value = val.fileUrl;
};
const dialogSure = () => {
  if (!invoiceCredentials.value) {
    ElMessage.warning("请上传发票凭证");
    return;
  }
  let data = {
    deliveryType: deliveryType.value,
    id: rowId.value,
    invoiceCredentials: invoiceCredentials.value,
  };
  btnLoading.value = true;
  addInvoice(data)
    .then((res) => {
      if (res.code == 1) {
        ElMessage({
          message: (res.msg as string) || "操作成功",
          type: "success",
        });
      }
      handleCurrentChange(page.value.pageNum);
      openShow.value = false;
      btnLoading.value = false;
    })
    .catch(() => {
      btnLoading.value = false;
    });
};
const changeImg = (url: string) => {
  imgurl.value = url;
  imgViewerVisible.value = true;
};
const routerJump = (val: any) => {
  // resolve新窗口打开
  const newpage = router.resolve({
    path: "/Merchantmanagement/Businesslistings", // 跳转的页面路由
    query: {
      // 要传的参数
      val: val,
    },
  });
  window.open(newpage.href, "_blank"); // 打开新的窗口(跳转路径，跳转类型)
};

return (_ctx: any,_cache: any) => {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_Redprompt = _resolveComponent("Redprompt")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_MyUpload = _resolveComponent("MyUpload")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "付费记录",
      img: headerimg.value,
      text: headercontent.value
    }, null, 8, ["img", "text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Publicform, {
          formList: state.formList,
          ref: "addAndEditDom",
          onChangeSelect: changeSelect,
          onSubmitForm: submitForm
        }, null, 8, ["formList"]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MyTable, {
            isLoading: isLoading.value,
            tableData: tableData.value,
            currentPage: page.value.pageNum,
            pageSize: page.value.pageSize,
            total: page.value.total,
            ifselection: false,
            isPagination: true,
            isHeight: false,
            isIndex: true,
            tableColumn: tableColumn.value,
            onHandleCurrentChange: handleCurrentChange,
            onHandleSizeChange: handleSizeChange
          }, {
            orderStatus: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "90px",
                label: "订单状态",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.orderStatus == "01" ? "已完成" : ""), 1)
                ]),
                _: 1
              })
            ]),
            type: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "90px",
                label: "类型",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.type == "01" ? "首购" : row.type == "02" ? "续费" : "扩店"), 1),
                  _createElementVNode("div", {
                    class: "click-style",
                    onClick: ($event: any) => (btnClick(row, 'vou'))
                  }, "付费凭证", 8, _hoisted_5)
                ]),
                _: 1
              })
            ]),
            merchantName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "商户全称",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: "click-style",
                    onClick: ($event: any) => (routerJump(row.merchantSimpleName))
                  }, _toDisplayString(row.merchantName), 9, _hoisted_6)
                ]),
                _: 1
              })
            ]),
            orderPrice: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "90px",
                label: "订单金额",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, "￥" + _toDisplayString(row.orderPrice), 1)
                ]),
                _: 1
              })
            ]),
            invoiceStatus: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "90px",
                label: "开票状态",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    style: _normalizeStyle(row.invoiceStatus == '01' ? 'color:#FF687B' : 'color:#0981FF')
                  }, _toDisplayString(row.invoiceStatus == "01" ? "未开票" : "已开票"), 5)
                ]),
                _: 1
              })
            ]),
            info: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "280px",
                label: "详情",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.type == '01')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 首购时长:" + _toDisplayString(row.renewalTime) + "个月，价格：￥" + _toDisplayString(row.orderPrice) + _toDisplayString(row.ruleValue != "10" ? `（${row.ruleValue}折）` : "") + "，首购门店数:" + _toDisplayString(row.renewalStoreNum || 0) + "家 ", 1))
                    : _createCommentVNode("", true),
                  (row.type == '02')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 续费时长:" + _toDisplayString(row.renewalTime) + "个月，价格：￥" + _toDisplayString(row.orderPrice) + _toDisplayString(row.ruleValue != "10" ? `（${row.ruleValue}折）` : "") + "，续费门店数:" + _toDisplayString(row.renewalStoreNum || 0) + "家，续费时剩余天数: " + _toDisplayString(row.renewalBeforeDay) + "天 ", 1))
                    : _createCommentVNode("", true),
                  (row.type == '03')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " 价格：￥" + _toDisplayString(row.orderPrice) + _toDisplayString(row.ruleValue != "10" ? `（${row.ruleValue}折）` : "") + "，扩店门店数:" + _toDisplayString(row.renewalStoreNum || 0) + "家，扩店时剩余天数: " + _toDisplayString(row.renewalBeforeDay) + "天 ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "190px",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    round: "",
                    onClick: ($event: any) => (btnClick(row, 'oper'))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (row.invoiceStatus == '01')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "success",
                        size: "small",
                        round: "",
                        onClick: ($event: any) => (btnClick(row, 'add'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "warning",
                        style: {"background":"#fcad29","border":"none"},
                        size: "small",
                        round: "",
                        onClick: ($event: any) => (btnClick(row, 'see'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["isLoading", "tableData", "currentPage", "pageSize", "total", "tableColumn"])
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: openShow.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((openShow).value = $event)),
          title: dialogTitle.value,
          width: "500px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_59, [
              _createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (openShow.value = false)),
                style: {"border":"1px solid #0981ff","color":"#0981ff"}
              }, {
                default: _withCtx(() => [
                  _hoisted_60
                ]),
                _: 1
              }),
              (dialogType.value == 'add')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    loading: btnLoading.value,
                    onClick: dialogSure
                  }, {
                    default: _withCtx(() => [
                      _hoisted_61
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            (dialogType.value == 'add')
              ? (_openBlock(), _createBlock(_component_Redprompt, {
                  key: 0,
                  text: "说明:添加开票是指商户订单支付后，财务人员已经开具发票且已交付商户"
                }))
              : _createCommentVNode("", true),
            (dialogType.value == 'add')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(dialogInfo.value.merchantName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_radio_group, {
                        modelValue: deliveryType.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deliveryType).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: '01' }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: '02' }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: '03' }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_MyUpload, {
                        imageUrl: invoiceCredentials.value,
                        tipText: "上传一张交付商户的发票截图凭证",
                        onChangeImg: uploadChangeImg
                      }, null, 8, ["imageUrl"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, _toDisplayString(dialogInfo.value.merchantName), 1)
                  ]),
                  (dialogType.value == 'see')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, _toDisplayString(dialogInfo.value.deliveryType == "01" ? "邮件发送" : dialogInfo.value.deliveryType == "02" ? "快递邮寄" : "其它方式"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'see')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, _toDisplayString(dialogInfo.value.invoiceCreateTime), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'see')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, _toDisplayString(dialogInfo.value.invoiceUserName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'see')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_el_image, {
                            zIndex: 8888,
                            class: "classimg",
                            src: dialogInfo.value.invoiceCredentials,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeImg(dialogInfo.value.invoiceCredentials)))
                          }, null, 8, ["src"]),
                          _hoisted_42
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'oper')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, _toDisplayString(dialogInfo.value.userName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'oper')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, _toDisplayString(dialogInfo.value.createTime), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'vou')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, _toDisplayString(dialogInfo.value.payPayerName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'vou')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, _toDisplayString(dialogInfo.value.payPayerPhone), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (dialogType.value == 'vou')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_el_image, {
                            zIndex: 8888,
                            class: "classimg",
                            src: dialogInfo.value.payCredentials,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeImg(dialogInfo.value.payCredentials)))
                          }, null, 8, ["src"]),
                          _hoisted_58
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        (imgViewerVisible.value)
          ? (_openBlock(), _createBlock(_component_el_image_viewer, {
              key: 0,
              "url-list": [imgurl.value],
              onClose: _cache[5] || (_cache[5] = ($event: any) => (imgViewerVisible.value = false))
            }, null, 8, ["url-list"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})